import { CLOSE_AUCTION_CONTRACT_MODAL, FETCH_OFFER } from 'dealer-reducers'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import View from 'src/components/atoms/View'
import CloseXSvg from 'src/components/other/svg/CloseXSvg'
import { RootReducer } from 'src/redux/rootReducer'
import AuctionContractModalContent from './AuctionContractModalContent'
import ThankYouAuctionContractModalContent from './ThankYouAuctionContractModalContent'

const AuctionContractModal = (): JSX.Element => {
  const dispatch = useDispatch()
  const { thankYouVariant, offerId, highestBet } = useSelector((state: RootReducer) => state.tableToolsReducer)
  const showAuctionContractModal = useSelector((state: RootReducer) => state.tableToolsReducer.showAuctionContractModal)

  useEffect(() => {
    return () => {
      dispatch(CLOSE_AUCTION_CONTRACT_MODAL())
    }
  }, [dispatch])

  return (
    <View
      style={{
        transform: showAuctionContractModal ? 'translateY(0)' : 'translateY(-110%)',
        transition: 'transform 0.5s'
      }}
      className="absolute left-0 top-0 bg-groupBlue w-full z-40 rounded-4 h-full overflow-hidden">
      <CloseXSvg
        className="flex justify-center items-center border border-white w-8 h-8 rounded-4 text-white absolute top-3 right-3 cursor-pointer"
        svgStyles="w-3 h-3"
        onClick={() => {
          dispatch(CLOSE_AUCTION_CONTRACT_MODAL())
          if (thankYouVariant) {
            dispatch(FETCH_OFFER({ id: offerId }))
          }
        }}
      />
      {thankYouVariant ? (
        <ThankYouAuctionContractModalContent />
      ) : (
        <AuctionContractModalContent offerId={offerId} highestBet={highestBet} />
      )}
    </View>
  )
}

export default AuctionContractModal
